import { useTranslations } from 'contexts/Translation'
import PropTypes from 'prop-types'
import { Title, Button } from '@qonsoll/react-design'
import { MAX_LENGTH_FIELD, MAX_LENGTH_DESCRIPTION, KEYS } from '__constants__'
import { Form, Input } from 'antd'
import { ImageUploader } from 'components'

const FeatureSimpleForm = (props) => {
  const { initialValues, onSubmit, onCancel, showTitle, form, group } = props

  // [ADDITIONAL_HOOKS]
  const { t } = useTranslations()
  const [baseForm] = Form.useForm()

  // [COMPUTED_PROPERTIES]
  const usedForm = form || baseForm

  // [HANDLERS]
  const handleCancel = () => {
    usedForm.resetFields()
    onCancel?.()
  }
  const handleKeyPress = (e) => {
    if (e.key === KEYS.ENTER) {
      e.preventDefault()
      e.stopPropagation()
      usedForm?.submit()
    }
  }

  return group ? (
    <>
      {showTitle && (
        <Title level={4} mb={2}>
          {t('Feature')}
        </Title>
      )}
      <Form.Item
        label={t('Feature logo u r l')}
        name={[...group, 'featureLogoURL']}
        rules={[
          {
            required: false,
            message: t('Please enter your feature feature logo u r l!')
          }
        ]}>
        <ImageUploader
          placeholder={t('Please enter your feature feature logo u r l')}
        />
      </Form.Item>
      <Form.Item
        label={t('Name')}
        name={[...group, 'name']}
        rules={[
          {
            required: true,
            message: t('Please enter your feature name!')
          },
          { max: MAX_LENGTH_FIELD, message: t('feature name is too long!') }
        ]}>
        <Input placeholder={t('Please enter your feature name')} />
      </Form.Item>
      <Form.Item
        label={t('Estimation')}
        name={[...group, 'estimation']}
        rules={[
          {
            required: false,
            message: t('Please enter your feature estimation!')
          },
          {
            max: MAX_LENGTH_FIELD,
            message: t('feature estimation is too long!')
          }
        ]}>
        <Input
          placeholder={t('Please enter your feature estimation')}
          onPressEnter={onSubmit}
        />
      </Form.Item>
    </>
  ) : (
    <Form
      form={usedForm}
      initialValues={initialValues}
      onFinish={onSubmit}
      layout="vertical"
      onKeyPress={handleKeyPress}
      autoComplete="off">
      {showTitle && (
        <Title level={4} mb={2}>
          {t('Feature')}
        </Title>
      )}
      <Form.Item
        label={t('Feature logo u r l')}
        name="featureLogoURL"
        rules={[
          {
            required: false,
            message: t('Please enter your feature feature logo u r l!')
          }
        ]}>
        <ImageUploader
          placeholder={t('Please enter your feature feature logo u r l')}
        />
      </Form.Item>
      <Form.Item
        label={t('Name')}
        name="name"
        rules={[
          {
            required: true,
            message: t('Please enter your feature name!')
          },
          { max: MAX_LENGTH_FIELD, message: t('feature name is too long!') }
        ]}>
        <Input placeholder={t('Please enter your feature name')} />
      </Form.Item>
      <Form.Item
        label={t('Estimation')}
        name="estimation"
        rules={[
          {
            required: false,
            message: t('Please enter your feature estimation!')
          },
          {
            max: MAX_LENGTH_FIELD,
            message: t('feature estimation is too long!')
          }
        ]}>
        <Input placeholder={t('Please enter your feature estimation')} />
      </Form.Item>
      {!form && (
        <>
          <Button mr={2} htmlType="button" onClick={handleCancel}>
            {t('Cancel')}
          </Button>
          <Button type="primary" onClick={() => usedForm.submit()}>
            {t('Save')}
          </Button>
        </>
      )}
    </Form>
  )
}

FeatureSimpleForm.propTypes = {
  initialValues: PropTypes.object,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  showTitle: PropTypes.bool,
  form: PropTypes.any,
  group: PropTypes.array
}

export default FeatureSimpleForm
